import { render, staticRenderFns } from "./SubscribersTable.vue?vue&type=template&id=bb3c9254&scoped=true"
import script from "./SubscribersTable.vue?vue&type=script&lang=js"
export * from "./SubscribersTable.vue?vue&type=script&lang=js"
import style0 from "./SubscribersTable.vue?vue&type=style&index=0&id=bb3c9254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3c9254",
  null
  
)

export default component.exports